import { useEffect, useState } from 'react';

import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { EventFormsDialog } from '../../../../types/event-bus';
import { Dialog } from './styles';

export default function ModalNoDobOrEmailOrSms() {
    const [open, setOpen] = useState(false);

    const { listen } = useEventBus();

    useEffect(() => {
        return listen('formsDialog', (event: any) => {
            const data = event.data as EventFormsDialog['data'];

            if (data.type === 'no-dob-or-email-or-sms') {
                setOpen(true);
            }
        });
    }, [listen]);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Unable to complete action</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    The patient's mobile phone number or email address along with date of birth are required. Please
                    update the patient's information within your practice's PMS and try again once the data sync is
                    complete.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
}
